export default {
  defaultLanguage: 'vi',
   apiPrefix: ''
   //apiPrefix: '/api'
};